import { spread as _$spread } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { TimeToFirstDrawRenderable } from "@opentui/core";
import { extend } from "./elements/index.js";
extend({
  time_to_first_draw: TimeToFirstDrawRenderable
});
export const TimeToFirstDraw = props => {
  return (() => {
    var _el$ = _$createElement("time_to_first_draw");
    _$spread(_el$, props, false);
    return _el$;
  })();
};